import { Alert, Col, Label, ReactSelectBox, Row, RadioContainer } from "client/CommonComponents";
import './AddUser.scss'
import { ASSET_INVENTORY_CONSTANTS } from "client/utils/constants/assetInventory";

const AddUser = (props:any) => {
    const { 
        usersOption, 
        userDetails, 
        onChangeUserName,
        filterOptionUser,
        userSelectOnBlur,
        userSearchText,
        userById,
        userCreated,
        searchBy,
        onChangeSearchBy  
    } = props

      return(
        <Row className="add-user-block">
             <Col xs={12} sm={12} md={7} lg={7} xl={7} className='mb-3'>
                <Label required data-attribute="AddUser_Default_Label">User Name</Label>
                <ReactSelectBox
                    options={usersOption}
                    onChange={(item: any) => onChangeUserName(item)}
                    value={userDetails?.userName}
                    name='userName'
                    isSearchable={true}
                    inputValue={userSearchText}
                    onInputChange={(value: any, action: any) => filterOptionUser(value, action)}
                    className={userDetails?.userError?.length > 0 ? 'controlValidation' : ''}
                    onBlur={userSelectOnBlur}
                    placeholder='Search by User name or Emp#'
                 data-attribute="AddUser_userName_SearchSelectBox" />
                {userDetails?.userError ? <p className='validMessage mt-0'>{userDetails?.userError}</p> : ''}
            </Col>  
            <Col xs={12} sm={12} md={5} lg={5} xl={5} className='mb-3 search-by-radios'>
                <Label data-attribute="AddUser_Default_Label_2">Search User By :</Label>
                  <RadioContainer
                      id={"id"}
                      options={[
                          { key: "name", text: "User Name" },
                          { key: "id", text: "Emp#" },
                      ]}
                      selectedKey={searchBy}
                      onChange={onChangeSearchBy}
                   data-attribute="AddUser_Default_Radio" />
            </Col>  
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className='mb-3'>
                <Label className="mb-1" data-attribute="AddUser_Default_Label_3">Cost Center</Label>
                <p>{userById?.costcentername ?? '-'}</p>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className='mb-3'>
                <Label className="mb-1" data-attribute="AddUser_Default_Label_4">Market</Label>
                <p>{userById?.marketname?.trim().length ? userById?.marketname : '-'}</p>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} className='mb-3'>
                <Label className="mb-1" data-attribute="AddUser_Default_Label_5">Region</Label>
                <p>{userById?.regionname ?? '-'}</p>
            </Col>          
            <Alert  
                type={userCreated === ASSET_INVENTORY_CONSTANTS.SUCCESS ? 'success' : 'error' }
                text={userCreated === ASSET_INVENTORY_CONSTANTS.SUCCESS ? 'User Added Successfully' : 'Error Adding User, Please try again'}
                showAlert={userCreated === ASSET_INVENTORY_CONSTANTS.SUCCESS || userCreated === ASSET_INVENTORY_CONSTANTS.FAILED}
             data-attribute="AddUser_Default_Alerts" />         
        </Row>
    )
}

export default AddUser;